import type { DiagnosisGroupDto } from '../diagnoses/diagnosis-group.dto';
import type { DAHTAssessmentDto } from './assessment.dto';

export class DAHTSessionDto {
  id: string;
  options: DiagnosisGroupDto;
  assessments: DAHTAssessmentDto[];
}
